import { useEffect, useState } from "react";
import { Minus, Plus } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { useCart } from "../lib/cart";
import { money } from "../lib/api";

export const ProductModal = ({ product, onClose }) => {
  const { add } = useCart();
  const [color, setColor] = useState(null);
  const [qty, setQty] = useState(1);

  useEffect(() => {
    setColor(product?.colors?.[0] ?? null);
    setQty(1);
  }, [product]);

  const p = product;
  return (
    <Dialog open={!!p} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="product-modal" data-lenis-prevent
        className="max-w-4xl w-[94vw] p-0 overflow-hidden rounded-[24px] sm:rounded-[28px] border-[2.5px] border-[var(--ink)] bg-[var(--paper)] shadow-[8px_8px_0_#14101F] max-h-[88vh] overflow-y-auto [&>button]:z-20 [&>button]:bg-white [&>button]:rounded-full [&>button]:p-2 [&>button]:border-2 [&>button]:border-[var(--ink)] [&>button]:opacity-100 [&>button]:right-3 [&>button]:top-3">
        {p && (
          <div className="grid md:grid-cols-2">
            <div className="bg-[var(--yellow)] p-3 sm:p-6 border-b-2 md:border-b-0 md:border-r-2 border-[var(--ink)]">
              <div className="aspect-[4/3] md:aspect-square rounded-[16px] sm:rounded-[20px] overflow-hidden border-2 border-[var(--ink)]">
                <img src={p.image} alt={p.name} className="w-full h-full object-cover" />
              </div>
            </div>
            <div className="p-5 sm:p-8 pb-0 sm:pb-8 flex flex-col gap-4 sm:gap-5">
              <p className="font-mono-x text-xs uppercase tracking-[0.18em] text-[#5a5470]">{p.category} · {p.material}</p>
              <DialogTitle className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight leading-none">{p.name}</DialogTitle>
              <p className="font-mono-x text-2xl font-bold" data-testid="product-modal-price">{money(p.price)}</p>
              <DialogDescription className="text-base leading-relaxed text-[#3b3550]">{p.description}</DialogDescription>
              {p.courier_fee != null && (
                <p data-testid="product-modal-courier" className="text-sm font-semibold">Courier for this item: {money(p.courier_fee)} (free pickup available)</p>
              )}
              {p.colors?.length > 0 && (
                <div>
                  <p className="font-semibold mb-2">Colour</p>
                  <div className="flex flex-wrap gap-2">
                    {p.colors.map((c) => (
                      <button key={c} data-testid={`product-color-${c.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => setColor(c)}
                        className={`px-3 py-1.5 rounded-full border-2 border-[var(--ink)] text-sm font-semibold transition-colors ${color === c ? "bg-[var(--ink)] text-[var(--paper)]" : "bg-white hover:bg-[var(--cyan)]"}`}>
                        {c}
                      </button>
                    ))}
                  </div>
                </div>
              )}
              <div className="sticky bottom-0 -mx-5 sm:mx-0 px-5 sm:px-0 py-4 sm:py-0 bg-[var(--paper)] border-t-2 sm:border-t-0 border-[var(--ink)] flex items-center gap-3 sm:gap-4 mt-auto sm:pt-2">
                <div className="flex items-center rounded-full border-2 border-[var(--ink)] bg-white">
                  <button data-testid="product-qty-minus" onClick={() => setQty((q) => Math.max(1, q - 1))} className="w-11 h-11 grid place-items-center" aria-label="Decrease"><Minus className="w-4 h-4" /></button>
                  <span data-testid="product-qty" className="w-8 text-center font-mono-x font-bold">{qty}</span>
                  <button data-testid="product-qty-plus" onClick={() => setQty((q) => q + 1)} className="w-11 h-11 grid place-items-center" aria-label="Increase"><Plus className="w-4 h-4" /></button>
                </div>
                <button data-testid="product-modal-add-btn" onClick={() => { add(p, color, qty); onClose(); }}
                  className="flex-1 press chunk-sm rounded-full bg-[var(--pink)] text-white font-bold py-3">
                  Add to cart
                </button>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
